import React, { Fragment, useEffect, useRef, useState } from 'react';
import GnbHeader from '../components/GnbHeader';
import Navigation from '../components/Navigation';
import '../styles/Program.css';
import '../styles/Video.css';
import AlcFooter from '../components/AlcFooter';
import { useWindowWidth, getToken } from '../js/calculator';
import axios from 'axios';
import TimeTableThirty from '../components/TimeTableThirty';
import TimeTableTen from '../components/TimeTableTen';
import { yearArr3 } from '../mockData/mockData';

const Program = ({ lang, bg }) => {
	const programListRef = useRef(null);
	// 세션에서 vod 팝업 열려있는지
	const [videoPopSess, setVideoPopSess] = useState(() => {
		// 세션스토리지에서 값을 가져오거나 기본값 'false' 사용
		return sessionStorage.getItem('videoPop') || 'false';
	});

	const [programPopSess, setProgramPopSess] = useState(() => {
		return sessionStorage.getItem('programPop') || 'false';
	});

	// 로딩 화면
	const [isLoading, setIsLoading] = useState(false);
	const isMobile = useWindowWidth();
	// 라이브 버튼 상태 변경
	const [onLive, setOnLive] = useState(false);
	// 프로그램 리스트
	const [programList, setProgramList] = useState();
	// 트랙 배열 갯수
	const [programListLength, setProgramListLength] = useState(0);
	// 트랙 있는지 없는지
	const [isTrack, setIsTrack] = useState({
		track1: false,
		track2: false,
		track3: false,
		track4: false,
		track5: false,
		track6: false,
	});
	// 해당 프로그램 팝업창 열고 닫고
	const [programPop, setProgramPop] = useState(false);
	// 프로그램 팝업창에 담길 정보
	const [popContents, setPopContents] = useState();
	// 현재 열려있는 연사의 인덱스
	const [openSpeaker, setOpenSpeaker] = useState(null);
	// 좌장용
	const [openModerator, setOpenModerator] = useState(null);
	// 비디오 팝업 상태
	const [videoPop, setVideoPop] = useState(true);
	// 모바일 장소 id값
	const [hallId, setHallId] = useState(0);
	// 비디오 팝업창에 들어갈 데이터
	const [videoData, setVideoData] = useState();
	// 비디오 에러 데이터
	const [error, setError] = useState();
	// 팝업 uuid
	const [popUuid, setPopUuid] = useState();
	// 팝업 영어 btn
	const [onEng, setOnEng] = useState(true);
	// 팝업 국문 btn
	const [onKor, setOnKor] = useState(false);
	// 상태에 키 추가
	const [showPlayer, setShowPlayer] = useState(true);
	const [windowWidth, setWindowWidth] = useState(
		typeof window !== 'undefined' ? window.innerWidth : 0,
	);

	const pdfUrl =
		lang === 'en'
			? 'https://image.chosun.com/alc/2026/alc-2026-program-eng.pdf'
			: 'https://image.chosun.com/alc/2026/alc-2026-program-kor.pdf';

	// 플로팅 버튼 자동으로 on
	const [onFloat, setOnFloat] = useState(false);
	// 시간
	const [time, setTime] = useState(0);

	const toggleOpen = (type, idx) => {
		if (type === 1) {
			// 연사
			if (openSpeaker === idx) {
				setOpenSpeaker(null); // 동일한 인덱스를 클릭하면 닫음
			} else {
				setOpenSpeaker(idx); // 다른 인덱스를 클릭하면 열음
			}
		} else if (type === 2) {
			// 좌장
			if (openModerator === idx) {
				setOpenModerator(null); // 동일한 인덱스를 클릭하면 닫음
			} else {
				setOpenModerator(idx); // 다른 인덱스를 클릭하면 열음
			}
		}
	};

	const toggleClose = () => {
		setOpenSpeaker(null);
		setOpenModerator(null);
	};

	const clickLive = () => {
		setOnLive(!onLive);
	};

	const [selectFirstDay, setSelectFirstDay] = useState(true);
	const [selectSecondDay, setSelectSecondDay] = useState(false);
	// 연도 배열
	const now = new Date(); // 현재 날짜 및 시간
	const year = now.getFullYear(); // 연도
	// let yearArr = [];
	// let noProgram = [2011, 2010, 2009, 2007, 2006]
	// for (let i = 0; i < year - 2004; i++) {
	//   yearArr.push(year - i)
	// }

	const [selectYear, setSelectYear] = useState(2026);

	const handleSelectYear = e => {
		setSelectYear(e.target.value);
	};

	const getSpeakerNames = (speakerInfoDtos, language) => {
		return speakerInfoDtos
			.map(speaker => (language === 'en' ? speaker.speakerNmEn : speaker.speakerNmKr))
			.join(' / ');
	};

	const handleLanguageChange = isEng => {
		// 언어 상태 업데이트
		setOnEng(isEng);
		setOnKor(!isEng);

		// 플레이어 숨기기
		setShowPlayer(false);

		// 약간의 지연 후 플레이어 다시 표시
		setTimeout(() => {
			setShowPlayer(true);

			// 플레이어가 다시 렌더링된 후 powaBoot 실행
			setTimeout(() => {
				if (typeof window !== 'undefined' && window.powaBoot) {
					window.powaBoot();
				}
			}, 100);
		}, 100);
	};
	const timeHeight = (end, start) => {
		const itemHeight = 206;
		if (end - start > 30) {
			const total = (end - start) / 30;
			return 438 + (total - 2) * 232; // 첫 시작값 438 + (현재 total - 시작 total) * 증가값
		}
		return itemHeight;
	};

	const titleFont = (end, start) => {
		if (end - start > 30) {
			return 'program_title_font';
		} else {
			return 'program_title_font_el';
		}
	};

	const descFont = (end, start) => {
		if (end - start > 30) {
			return 'program_item_desc';
		} else {
			return 'program_item_desc_el';
		}
	};

	const popClose = () => {
		setVideoPop(false);
		sessionStorage.setItem('videoPop', 'false');
		setOnEng(true);
		setOnKor(false);
		setPopUuid('');
	};

	const getProgramList = async () => {
		try {
			setIsLoading(true);
			const response = await axios.get(
				`${process.env.REACT_APP_BASE_URL}/v1/program?lang=${lang === 'en' ? 'ENG' : 'KOR'}&year=${selectYear}&day=${selectFirstDay ? 1 : 2}`,
			);

			setProgramList(response?.data);
			setProgramListLength(response?.data?.trackList?.length);
		} catch (error) {
			// console.error(`Error: ${error}`);
		} finally {
			setIsLoading(false);
			// alert(
			// 	lang === 'en'
			// 		? 'The ALC 2026 program is currently in preparation.'
			// 		: 'ALC 2026 프로그램은 현재 준비 중입니다.',
			// );
		}
	};

	// 비디오 팝업 호출하는 api
	const getVideopopData = programId => {
		axios
			.get(`${process.env.REACT_APP_BASE_URL}/v1/program/video/${programId}/watch`, {
				headers: { Authorization: getToken() === null ? null : `Bearer ${getToken()}` },
			})
			// 성공
			.then(res => {
				setVideoPop(true);
				sessionStorage.setItem('videoPop', 'true');
				setVideoData(res?.data);
				if (res?.data?.uuidEn !== '') {
					setPopUuid(res?.data?.uuidEn);
				}
				if (res?.data?.uuidEn === '') {
					setPopUuid(res?.data?.uuidKr);
				}
			})
			// 실패
			.catch(err => {
				// setVideoPop(false)
				setError(err?.response?.data?.errorCode);
				console.log('err!!!', err?.response?.data?.errorCode);
				alert(lang === 'en' ? err?.response?.data?.msgEn : err?.response?.data?.msgKr);
				if (err?.response?.data?.errorCode === 'PAYMENT_REQUIRED') {
					window.location.href = lang === 'en' ? '/en/register' : '/register';
				}
				if (err?.response?.data?.errorCode === 'INVALID_PERMISSION') {
					window.location.href =
						lang === 'en'
							? 'https://www.chosun.com/en/subscribe/signin/'
							: 'https://www.chosun.com/subscribe/signin/';
				}
			});
	};

	useEffect(() => {
		sessionStorage.setItem('videoPop', 'false');
		sessionStorage.setItem('programPop', 'false');
	}, []);

	useEffect(() => {
		const script = document.createElement('script');
		script.src = 'https://d328y0m0mtvzqc.cloudfront.net/prod/powaBoot.js';
		script.async = true;
		document.body.appendChild(script);
		return () => {
			document.body.removeChild(script);
		};
	}, []);

	// useEffect(() => {
	// 	// Handles if the powa script finishes loading before the component is ready.
	// 	if (typeof window !== 'undefined' && window.powaBoot) {
	// 		window.powaBoot();
	// 	}
	// }, [popUuid]);

	useEffect(() => {
		if (!popUuid) return;

		// 약간의 지연을 두고 powaBoot 실행
		const timer = setTimeout(() => {
			if (typeof window !== 'undefined' && window.powaBoot) {
				window.powaBoot();
			}
		}, 100);

		return () => clearTimeout(timer);
	}, [popUuid]);

	// 플로팅 버튼 자동으로 나오게 함
	useEffect(() => {
		let startDate = new Date(
			programList?.firstDay.split('T')[0] + 'T' + programList?.firstStart + ':00',
		);
		let endDate = new Date(programList?.secondDay.split('T')[0] + 'T23:59:59');
		const checkTime = () => {
			const now = new Date();
			if (now >= startDate && now <= endDate) {
				setOnFloat(true);
			} else {
				setOnFloat(false);
			}
		};
		window.onload = checkTime(); // Initial check when component mounts

		const interval = setInterval(checkTime(), 1000); // Check every second

		return () => clearInterval(interval); // Clean up interval on component unmount
	});

	// 페이지 자동으로 30분마다 리로드 대신 팝업창 열려있으면 리로드 안함
	// useEffect(() => {
	// 	// programListRef를 업데이트
	// 	programListRef.current = programList;
	// 	const { firstDay, secondDay, firstStart, lastEnd } = programListRef.current || {};
	// 	// console.log('programListRef.current', programListRef.current);

	// 	// 필수 데이터가 모두 존재하는지 확인
	// 	if (!firstDay || !secondDay || !firstStart || !lastEnd) {
	// 		return; // 데이터가 부족하면 함수 종료
	// 	}

	// 	// 시작 및 종료 시간을 정확히 계산
	// 	let selectedDay = selectFirstDay ? firstDay.split('T')[0] : secondDay.split('T')[0];
	// 	let startDateTime = new Date(`${selectedDay}T${firstStart}:00`);
	// 	let endDateTime = new Date(`${selectedDay}T${lastEnd}:00`);

	// 	const getTime = setInterval(() => {
	// 		// programListRef에서 필요한 데이터 추출
	// 		// 필수 데이터가 모두 존재하는지 확인
	// 		if (!firstDay || !secondDay || !firstStart || !lastEnd) {
	// 			return; // 데이터가 부족하면 함수 종료
	// 		}

	// 		let now = new Date();

	// 		// console.log('현재 시간:', now);
	// 		// console.log('시작 시간:', startDateTime);
	// 		// console.log('끝나는 시간:', endDateTime);
	// 		// console.log('now >= startDateTime', now >= startDateTime);
	// 		// console.log('now <= endDateTime', now <= endDateTime);

	// 		// 현재 시간이 시작 시간과 종료 시간 사이에 있고, 세션 스토리지 값들이 'false'인 경우에만 리로드
	// 		if (now >= startDateTime && now < endDateTime) {
	// 			setTime(time + 1);
	// 		}
	// 	}, 1800000);
	// 	// 60000 1분 300000 5분 1800000 30분

	// 	if (now === endDateTime) {
	// 		clearInterval(getTime);
	// 	}
	// 	return () => clearInterval(getTime);
	// }, [time]);

	// useEffect(() => {
	// 	// null 체크 추가
	// 	if (videoPopSess === null || programPopSess === null) {
	// 		return; // null일 때는 실행하지 않음
	// 	}
	// 	if (isMobile) {
	// 		getProgramList();
	// 	} else {
	// 		if (videoPopSess === 'false' && programPopSess === 'false') {
	// 			getProgramList();
	// 		}
	// 	}
	// }, [isMobile, time, videoPopSess, programPopSess, selectYear, selectFirstDay]);

	useEffect(() => {
		// 모바일이든 데스크톱이든 항상 프로그램 목록을 가져옵니다
		getProgramList();
	}, [isMobile, time, selectYear, selectFirstDay]);

	useEffect(() => {
		if (programList?.trackList) {
			const newIsTrack = {
				track1: false,
				track2: false,
				track3: false,
				track4: false,
				track5: false,
				track6: false,
			};

			programList.trackList.forEach(el => {
				if (el?.track1 !== undefined) newIsTrack.track1 = true;
				if (el?.track2 !== undefined) newIsTrack.track2 = true;
				if (el?.track3 !== undefined) newIsTrack.track3 = true;
				if (el?.track4 !== undefined) newIsTrack.track4 = true;
				if (el?.track5 !== undefined) newIsTrack.track5 = true;
				if (el?.track6 !== undefined) newIsTrack.track6 = true;
			});
			setIsTrack(newIsTrack);
		}
	}, [programList]);

	// 윈도우 리사이즈 이벤트 처리
	useEffect(() => {
		if (typeof window === 'undefined') return;

		// 전체화면 상태 추적 변수
		let wasInFullscreen = false;
		let fullscreenExitTime = 0;
		const FULLSCREEN_COOLDOWN = 1000; // 전체화면 종료 후 리사이즈 무시 시간 (밀리초)

		// 전체화면 변경 감지 함수
		const handleFullscreenChange = () => {
			const isFullscreen = !!(
				document.fullscreenElement ||
				document.webkitFullscreenElement ||
				document.mozFullScreenElement ||
				document.msFullscreenElement
			);

			// 전체화면에서 일반화면으로 전환될 때 타임스탬프 기록
			if (wasInFullscreen && !isFullscreen) {
				fullscreenExitTime = Date.now();
			}

			wasInFullscreen = isFullscreen;
		};

		// 전체화면 이벤트 리스너 등록
		document.addEventListener('fullscreenchange', handleFullscreenChange);
		document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
		document.addEventListener('mozfullscreenchange', handleFullscreenChange);
		document.addEventListener('MSFullscreenChange', handleFullscreenChange);

		const handleResize = () => {
			// 현재 전체화면 상태 확인
			const isFullscreen = !!(
				document.fullscreenElement ||
				document.webkitFullscreenElement ||
				document.mozFullScreenElement ||
				document.msFullscreenElement
			);

			// 전체화면 상태이거나, 전체화면 종료 직후 쿨다운 기간인 경우 무시
			const isInCooldown = Date.now() - fullscreenExitTime < FULLSCREEN_COOLDOWN;

			if (isFullscreen || isInCooldown) {
				return;
			}

			// 일반 상태에서만 플레이어 재초기화
			setWindowWidth(window.innerWidth);

			// 플레이어 재초기화
			setShowPlayer(false);
			setTimeout(() => {
				setShowPlayer(true);
				setTimeout(() => {
					if (typeof window !== 'undefined' && window.powaBoot) {
						window.powaBoot();
					}
				}, 100);
			}, 100);
		};

		// 디바운스 처리 (리사이즈 이벤트가 너무 자주 발생하지 않도록)
		let resizeTimer;
		const debouncedResize = () => {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(handleResize, 250);
		};

		window.addEventListener('resize', debouncedResize);

		return () => {
			window.removeEventListener('resize', debouncedResize);
			document.removeEventListener('fullscreenchange', handleFullscreenChange);
			document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
			document.removeEventListener('mozfullscreenchange', handleFullscreenChange);
			document.removeEventListener('MSFullscreenChange', handleFullscreenChange);
		};
	}, []);

	// 컴포넌트 마운트 시 또는 videoData가 변경될 때 실행
	useEffect(() => {
		if (!videoData) return;

		const hasEng = videoData.uuidEn && videoData.uuidEn !== '';
		const hasKor = videoData.uuidKr && videoData.uuidKr !== '';

		// 초기 언어 및 UUID 설정
		if (hasEng) {
			setOnEng(true);
			setOnKor(false);
			setPopUuid(videoData.uuidEn);
		} else if (hasKor) {
			setOnEng(false);
			setOnKor(true);
			setPopUuid(videoData.uuidKr);
		}
	}, [videoData]);

	if (isLoading) {
		// return <Loading />
	} else {
		return (
			<Fragment>
				<div className="pageloader">
					<div className="dis_table">
						<div className="dis_table_cell">
							<img src="img/Eclipse-1s-244px.gif" alt="" />
						</div>
					</div>
				</div>
				<div className="state_indicator"></div>
				<div id="wrapper-program">
					<GnbHeader lang={lang} bg={bg} />
					<Navigation lang={lang} bg={bg} />
					<div className="alc_top_msg">
						<div className="pro_title_wrapper">
							<div className="pro_title">
								<strong>ALC {selectYear}</strong> PROGRAM
							</div>
							{parseInt(selectYear) === 2026 && (
								<>
									<a className="prgramm-down-btn" href={pdfUrl} target="_blank" rel="noreferrer">
										{lang === 'en' ? 'Download' : '다운로드'}
									</a>
									{/* <div
										className="prgramm-down-btn-disabled"
										href=""
										target="_blank"
										rel="noreferrer"
									>
										{lang === 'en' ? 'Download' : '다운로드'}
									</div> */}
								</>
							)}
						</div>
						<div className="select_cate">
							<p>{lang === 'en' ? 'filter' : '연도선택'}</p>
							<p>
								<label>
									<select
										value={selectYear}
										name=""
										id=""
										onChange={e => {
											handleSelectYear(e);
										}}
									>
										{yearArr3.map((ele, idx) => (
											<option value={ele} key={idx}>
												{ele}
											</option>
										))}
									</select>
									<img
										className="gallery-arrow-icon"
										src="//image.chosun.com/alc/2022//select_arrow.png"
									/>
								</label>
							</p>
						</div>
					</div>
					{programList?.year > 2019 ? (
						<TimeTableThirty
							lang={lang}
							programList={programList}
							selectFirstDay={selectFirstDay}
							setSelectFirstDay={setSelectFirstDay}
							selectSecondDay={selectSecondDay}
							setSelectSecondDay={setSelectSecondDay}
							hallId={hallId}
							setHallId={setHallId}
							onFloat={onFloat}
							onLive={onLive}
							clickLive={clickLive}
							programListLength={programListLength}
							timeHeight={timeHeight}
							programPop={programPop}
							setProgramPop={setProgramPop}
							popContents={popContents}
							setPopContents={setPopContents}
							getSpeakerNames={getSpeakerNames}
							getVideopopData={getVideopopData}
							isTrack={isTrack}
							openSpeaker={openSpeaker}
							openModerator={openModerator}
							toggleClose={toggleClose}
							videoData={videoData}
							toggleOpen={toggleOpen}
							videoPop={videoPop}
							onEng={onEng}
							setOnEng={setOnEng}
							onKor={onKor}
							setOnKor={setOnKor}
							setPopUuid={setPopUuid}
							popClose={popClose}
							selectYear={selectYear}
							titleFont={titleFont}
							descFont={descFont}
							handleLanguageChange={handleLanguageChange}
							showPlayer={showPlayer}
						/>
					) : (
						<TimeTableTen
							lang={lang}
							programList={programList}
							selectFirstDay={selectFirstDay}
							setSelectFirstDay={setSelectFirstDay}
							selectSecondDay={selectSecondDay}
							setSelectSecondDay={setSelectSecondDay}
							hallId={hallId}
							setHallId={setHallId}
							onFloat={onFloat}
							onLive={onLive}
							clickLive={clickLive}
							programListLength={programListLength}
							programPop={programPop}
							setProgramPop={setProgramPop}
							popContents={popContents}
							setPopContents={setPopContents}
							getSpeakerNames={getSpeakerNames}
							getVideopopData={getVideopopData}
							isTrack={isTrack}
							openSpeaker={openSpeaker}
							openModerator={openModerator}
							toggleClose={toggleClose}
							videoData={videoData}
							toggleOpen={toggleOpen}
							videoPop={videoPop}
							onEng={onEng}
							setOnEng={setOnEng}
							onKor={onKor}
							setOnKor={setOnKor}
							setPopUuid={setPopUuid}
							popClose={popClose}
						/>
					)}
					<AlcFooter lang={lang} bg={bg} />
				</div>
			</Fragment>
		);
	}
};

export default Program;
